import {Box, Button} from '@mui/material';
import Typography from '@mui/material/Typography';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import MultilineTextField from '../../../../shared-components/MultilineTextField';

function DescriptionSettings(
    {
        header,
        description,
        defaultDescription,
        onDescriptionChange,
        fieldLabel = 'Description',
        saveButtonText = 'Save description',
        rows
    }) {
    const [text, setText] = useState(description);
    const actions = text !== defaultDescription && defaultDescription
        ? [
            {
                label: 'Revert to Default Description',
                onClick: () => setText(defaultDescription)
            }
        ]
        : [];

    useEffect(() => {
        setText(description);
    }, [description]);

    return (
        <Box>
            {header
                ? <Typography variant="h6" fontWeight="bold" gutterBottom>{header}</Typography>
                : null
            }
            <MultilineTextField
                label={fieldLabel}
                value={text}
                onChange={setText}
                actions={actions}
                rows={rows}
            />
            {description !== text && (
                <>
                    {!text?.trim() && (
                        <Typography variant="body2" color="error" sx={{mt: 1}}>
                            Description cannot be empty
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!text?.trim()}
                        onClick={() => onDescriptionChange(text)}
                        sx={{
                            marginTop: 1,
                            backgroundColor: '#186BBE',
                            boxShadow: 'none',
                            width: { xs: '100%', sm: 'auto' },
                            '&:hover': {
                                backgroundColor: '#155FA7',
                                boxShadow: 'none'
                            }
                        }}
                    >
                        {saveButtonText}
                    </Button>
                </>
            )}
        </Box>
    );
}

DescriptionSettings.propTypes = {
    header: PropTypes.string,
    description: PropTypes.string,
    defaultDescription: PropTypes.string,
    onDescriptionChange: PropTypes.func,
    fieldLabel: PropTypes.string,
    saveButtonText: PropTypes.string,
    rows: PropTypes.number
};

export default DescriptionSettings;
